<template>
    <div>
        <div id="proposal-settings-template-div">
            <div class="row">
                <div class="col-md-12 float-left">
                    <h5>Settings</h5>
                </div>
            </div>
            <div class="proposal-template-listing-div mt-3 col-md-12">
                <b-form-checkbox @change="proposalButtonSwitchUpdate" name="check-button" v-model="buttonAccess" id="proposalButtonSwitch" class="inline-block p-0" switch>
                </b-form-checkbox>
                <label for="proposalButtonSwitch" class="inline-block text-black font-weight-light cursor-pointer">Display Proposal Generator Button</label>
            </div>
            <div class="proposal-template-listing-div mt-3 col-md-12">
                <b-form-checkbox @change="proposalPageNumberUpdate" name="check-button" v-model="pageNumber" id="proposalPageNumber" class="inline-block p-0" switch>
                </b-form-checkbox>
                <label for="proposalPageNumber" class="inline-block text-black font-weight-light cursor-pointer">Display Page Number In Proposal Review</label>
            </div>
<!--            <div class="proposal-template-listing-div mt-3 col-md-12 p-0 text-black">-->
<!--                <p>Proposal Graphics</p>-->
<!--                <p class="text-sm font-weight-light mt-2">*Recommended size for Header and Footer Image 1800px width and 200px height. If the header or footer image is turned off then it will not appear in proposal pdf review.</p>-->
<!--            </div>-->
<!--            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">-->
<!--                <div class="p-0 col-md-6 float-left">-->
<!--                    <p class="text-sm mb-2">Proposal Header</p>-->
<!--                 </div>-->
<!--                <div class="p-0 col-md-6 float-left text-right">-->
<!--                    <b-form-checkbox @change="updateHeaderSwitch()" name="check-button" v-model="headerSwitch" id="headerSwitch" class="inline-block p-0" switch>-->
<!--                    </b-form-checkbox>-->
<!--                    <label for="headerSwitch" class="inline-block text-black font-weight-light cursor-pointer">{{headerSwitchText}}</label>-->
<!--                </div>-->
<!--                <div v-if="teamInfo.header_image_url" class="border-1 border-grey overflow-hidden col-md-12" style="height: 120px;border-radius: 2px">-->
<!--                    <div class="col-md-8 float-left overflow-hidden p-0 h-100">-->
<!--                        <div class="col-md-7 float-left overflow-hidden p-0 h-100">-->
<!--                            <div :style="'background-image:url('+teamInfo.header_image_url+'?'+randomInt+');background-size: contain;height: 100%;width: 380px;background-repeat: no-repeat;background-position-y: center;'"></div>-->
<!--                        </div>-->
<!--                        <div class="col-md-5 float-left overflow-hidden p-0 h-100 py-5 text-teal">-->
<!--                            {{headerImageName}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4 float-left text-right p-0 h-100">-->
<!--                        <span @click.prevent="deleteImageButton('header_image_url')" class="material-icons text-black col-1 cursor-pointer py-5">-->
<!--                            delete-->
<!--                        </span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-else class="border-1 border-grey overflow-hidden col-md-12 anka-div" style="border-radius: 2px">-->
<!--                    <image-cropper-->
<!--                        :url="headerFooterImageUploadUrl"-->
<!--                        :image-type="'header'"></image-cropper>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">-->
<!--                <div class="p-0 col-md-6 float-left">-->
<!--                    <p class="text-sm mb-2">Proposal Footer</p>-->
<!--                </div>-->
<!--                <div class="p-0 col-md-6 float-left text-right">-->
<!--                    <b-form-checkbox @change="updateFooterSwitch()" name="check-button" v-model="footerSwitch" id="footerSwitch" class="inline-block p-0" switch>-->
<!--                    </b-form-checkbox>-->
<!--                    <label for="footerSwitch" class="inline-block text-black font-weight-light cursor-pointer">{{footerSwitchText}}</label>-->
<!--                </div>-->
<!--                <div v-if="teamInfo.footer_image_url" class="border-1 border-grey overflow-hidden col-md-12" style="height: 120px;border-radius: 2px">-->
<!--                    <div class="col-md-8 float-left overflow-hidden p-0 h-100">-->
<!--                        <div class="col-md-7 float-left overflow-hidden p-0 h-100">-->
<!--                            <div :style="'background-image:url('+teamInfo.footer_image_url+'?'+randomInt+');background-size: contain;height: 100%;width: 380px;background-repeat: no-repeat;background-position-y: center;'"></div>-->
<!--                        </div>-->
<!--                        <div class="col-md-5 float-left overflow-hidden p-0 h-100 py-5 text-teal">-->
<!--                            {{footerImageName}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-4 float-left text-right p-0 h-100">-->
<!--                        <span @click.prevent="deleteImageButton('footer_image_url')" class="material-icons text-black col-1 cursor-pointer py-5">-->
<!--                            delete-->
<!--                        </span>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-else class="border-1 border-grey overflow-hidden col-md-12 anka-div" style="border-radius: 2px">-->
<!--                    <image-cropper-->
<!--                        :url="headerFooterImageUploadUrl"-->
<!--                        :image-type="'footer'"></image-cropper>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";
import ImageCropper from "../../shared/image-cropper";

export default {
    name: "proposal-settings-page",
    props:['team', 'headerFooterImageUploadUrl', 'baseUrl'],
    components: {ImageCropper},
    data() {
        return {
            teamInfo:this.team,
            buttonAccess:(this.team.has_proposal_button_access == 1)? true:false,
            pageNumber:(this.team.proposal_page_number == 1)? true:false,
            // headerSwitch:(this.team.header_image_show == 1)? true:false,
            // headerSwitchText:(this.team.header_image_show == 1)? 'On':'Off',
            // footerSwitch:(this.team.footer_image_show == 1)? true:false,
            // footerSwitchText:(this.team.footer_image_show == 1)? 'On':'Off',
            // headerImageName:(this.team.header_image_url)? this.team.header_image_url.split('/')[this.team.header_image_url.split('/').length-1]:'',
            // footerImageName:(this.team.footer_image_url)? this.team.footer_image_url.split('/')[this.team.footer_image_url.split('/').length-1]:'',
            // randomInt:Math.floor(Math.random() * 100)
        }
    },
    mounted(){
        this.fetchTeamInfo();
    },
    methods: {
        fetchTeamInfo(){
            axios.post(route('api.proposal-settings.team-info')).then((response) => {
                this.teamInfo = response.data.team;
                this.buttonAccess = (response.data.team.has_proposal_button_access == 1)? true:false;
                this.pageNumber = (response.data.team.proposal_page_number == 1)? true:false;
                // this.headerSwitch = (response.data.team.header_image_show == 1)? true:false;
                // this.headerSwitchText = (response.data.team.header_image_show == 1)? 'On':'Off';
                // this.footerSwitch = (response.data.team.footer_image_show == 1)? true:false;
                // this.footerSwitchText = (response.data.team.footer_image_show == 1)? 'On':'Off';
            });
        },
        proposalButtonSwitchUpdate(){
            this.$nextTick(()=>{
                var data = {
                    'access': (this.buttonAccess)? 1:0
                };
                axios.post('/settings/update-has-proposal-button-access', data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                );
            });
        },
        proposalPageNumberUpdate(){
            this.$nextTick(()=>{
                var data = {
                    'pageNumber': (this.pageNumber)? 1:0
                };
                axios.post('/settings/update-proposal-page-number', data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchTeamInfo();
                    }
                );
            });
        },
        updateHeaderSwitch(){
            this.$nextTick(()=>{
                var data = {
                    'type':'header',
                    'show': (this.headerSwitch)? 1:0
                };
                axios.post('/settings/update-header-footer-image-show', data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchTeamInfo();
                    }
                );
            });
        },
        updateFooterSwitch(){
            this.$nextTick(()=>{
                var data = {
                    'type':'footer',
                    'show': (this.footerSwitch)? 1:0
                };
                axios.post('/settings/update-header-footer-image-show', data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchTeamInfo();
                    }
                );
            });
        },
        deleteImageButton(type){
            axios.post('/settings/delete-header-footer-image', {
                type: type
            }).then((response) => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.fetchTeamInfo();
                }
            );
        }
    }
};
</script>

<style>
#proposal-settings-template-div {
    padding: 5px 0;
}
#proposal-settings-template-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.proposal-template-listing-heading-row{
    background: #f4f5f6;
    font-weight: 500;
}
.proposal-template-listing-row {
    font-weight: 300;
}
.proposal-template-listing-row .dropdown-item {
    font-weight: 300;
    font-size: 15px;
}
.proposal-template-listing-row:hover {
    background: #f5f5f5;
}

.red-box-shadow{
    box-shadow: 0px 0px 5px #01b1af;
}
.ankaCropper__droparea {
    border: none !important;
    margin: 0 !important;
    padding: 1em !important;
}
.ankaCropper.light {
    background: transparent !important;
}
.ankaCropper {
    box-shadow: none !important;
    border-radius: 0px !important;
    font-family: inherit !important;
}
.anka-div{
    background: #f8f9fa;
}
.ankaCropper.light .ankaCropper__saveButton,
.ankaCropper.light .ankaCropper__selectButton,
.ankaCropper.light .ankaCropper__selectButton svg.feather.feather-save,
.ankaCropper > svg{
    border: 1px solid #01b1af !important;
    background: transparent !important;
    color: #01b1af !important;
    stroke: #01b1af !important;
}
.ankaCropper.light .ankaCropper__saveButton:hover,
.ankaCropper.light .ankaCropper__selectButton:hover,
.ankaCropper.light .ankaCropper__selectButton:hover svg.feather.feather-save {
    background: #01b1af !important;
    color: white !important;
    stroke: white !important;
}
.ankaCropper__droparea div {
    font-weight: 300;
    background-image: url('https://stage.followupcrm.com/images/image-upload.png');
    background-repeat: no-repeat;
    background-position-x: center;
    height: 60px;
    background-size: 5%;
    padding-top: 61px;
    margin-bottom: 30px;
}
.ankaCropper.light .ankaCropper__navigation {
    background: transparent;
    box-shadow: none;
}

#proposal-settings-template-div .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #01b1af !important;
    border-color: #01b1af !important;
}
svg.feather.feather-save{
    background: transparent !important;
    color: #01b1af !important;
    stroke: #01b1af !important;
}

.ankaCropper__saveButton:hover svg.feather.feather-save{
    background: #01b1af !important;
    color: white !important;
    stroke: white !important;
}
</style>
